import AddIcon from '@mui/icons-material/Add'
import React, {useEffect, useState, useMemo, useCallback} from 'react'
import {
    Container,
    Body,
    Header,
    SignalSet,
    SignalSetElem,
    AddSet,
    HeadButton, Header2,
} from './Interpretations.style'
import TitleDescriptionInput from '../../../components/customInput/TitleDescriptionInput'
import {useAppDispatch, useAppSelector} from '../../../hooks/redux'
import {useLocation} from 'react-router-dom'
import {initCurrent, updateCurrent} from '../../../redux/slice/currentItem'
import _ from 'underscore'
import IdRecommendationsTable from '../../../components/tables/[id]/recommendations/IdRecommendations'
import IdInterPretationsTable from '../../../components/tables/[id]/interpretations/IdInterpretetions'
import {objectify} from '../../recommendations/[id]/Recommendations'
import ConnectToRecommendationTable from '../../../components/tables/connectTo/recommendations/connectToRecommendation'
import ConnectToSignalsTable from '../../../components/tables/connectTo/signals/signals'
import {ConnectModal} from '../../../components/customStyledElements'
import IndicatorsSignalTable from "../../../components/tables/main/indicators-signals-table/IndicatorsSignalTable";
import {Button, Input, Modal, Dialog, DialogTitle, DialogContent, DialogActions, TextField} from "@mui/material";
import MyModal from '../../../components/myModal/myModal'
import RecommendationsTable from "../../../components/tables/main/recommendation/RecommendationTable";
import {RemoveBtn} from "../../../components/listMenu/listMenu";
import {patchRemove} from "../../../redux/slice/data";
import WarningIcon from '@mui/icons-material/WarningTwoTone';
import {WarningCircle} from '../../biomarkers/[id]/IndicatorsAndSignals'
import CSVUploader from "./CSVUploader";
import Editor from "../../../components/CKEditor/editor";
import {LeftSide, NavElement} from '../../subjects/Subject.style';
import {getSubjectId} from '../../biomarkers/[id]/IndicatorsAndSignals';
import {postInterpretation} from '../../../api/smart-life';

const CONNECT_TO = {
    SIGNALS: 0,
    RECOMMENDATIONS: 1,
}

const Interpretations = () => {
    const MAX_ELEM_IN_LIST = 7

    const {interpretations, indicators, recommendations} = useAppSelector(
        (state) => state.data
    )
    const {currentItem} = useAppSelector((state) => state)
    const {pathname} = useLocation()
    const {user} = useAppSelector((state) => state.user.user)

    const [isConnectOpen, setIsConnectOpen] = useState<undefined | number>(
        undefined
    )
    const [language, setLanguage] = useState<string>('en')
    const [isAddLanguageModalOpen, setIsAddLanguageModalOpen] = useState(false)
    const [selectedNewLanguage, setSelectedNewLanguage] = useState('')
    const [localDescription, setLocalDescription] = useState('')
    const [selectedSet, setSelectedSet] = useState(0)

    useEffect(() => {
        const desc = typeof currentItem?.data?.description === 'object'
            ? currentItem.data.description[language] || (language === 'en' ? currentItem.data.description['en'] || '' : '')
            : currentItem?.data?.description || ''
        setLocalDescription(desc)
    }, [currentItem?.data?.description, language])

    useEffect(() => {
        const id = pathname.split('/').pop() || ''
        
        if (id === 'create-diseases') {
            // Создаем новую интерпретацию
            const newInterpretation = {
                name: { en: '' },
                description: { en: '' },
                signalSets: [{ signals: [] }],
                recommendationIds: [],
                subjectIds: [getSubjectId()]
            }
            dispatch(initCurrent({data: newInterpretation, type: 'interpretation'}))
        } else {
            // Загружаем существующую интерпретацию
            dispatch(initCurrent({data: interpretations[id], type: 'interpretation'}))
        }
    }, [])

    const currentInterpretation = currentItem.data || {}
    const dispatch = useAppDispatch()

    const availableLanguages = useMemo(() => {
        const name = currentItem?.data?.name
        return name && typeof name === 'object' ? Object.keys(name) : ['en']
    }, [currentItem?.data?.name])

    const handleRemoveLanguage = useCallback((langToRemove: string) => {
        if (availableLanguages.length <= 1) {
            alert('Cannot remove the last language')
            return
        }
        
        if (langToRemove === 'en') {
            alert('Cannot remove English language')
            return
        }
        
        if (window.confirm(`Are you sure you want to remove language "${langToRemove.toUpperCase()}"?`)) {
            const updatedName = { ...currentItem?.data?.name }
            delete updatedName[langToRemove]
            
            const updatedDescription = { ...currentItem?.data?.description }
            delete updatedDescription[langToRemove]
            
            dispatch(updateCurrent({
                name: updatedName,
                description: updatedDescription
            }))
            
            if (language === langToRemove) {
                setLanguage('en')
            }
        }
    }, [availableLanguages.length, currentItem?.data?.name, currentItem?.data?.description, dispatch, language])

    const handleAddLanguage = useCallback(() => {
        const code = selectedNewLanguage.toLowerCase().trim()
        if (!code || code.length > 2 || availableLanguages.includes(code) || !currentItem?.data) return

        const newNameObj =
            typeof currentItem.data.name === 'object'
                ? { ...currentItem.data.name, [code]: '' }
                : { en: currentItem.data.name || '', [code]: '' }

        const newDescriptionObj =
            typeof currentItem.data.description === 'object'
                ? { ...currentItem.data.description, [code]: '' }
                : { en: currentItem.data.description || '', [code]: '' }

        dispatch(updateCurrent({ name: newNameObj, description: newDescriptionObj }))
        setLanguage(code)
        setIsAddLanguageModalOpen(false)
        setSelectedNewLanguage('')
    }, [dispatch, selectedNewLanguage, availableLanguages, currentItem])

    const connectNewSignal = () => {
        setIsConnectOpen(CONNECT_TO.SIGNALS)
    }

    const connectNewRecommendations = () =>
        setIsConnectOpen(CONNECT_TO.RECOMMENDATIONS)

    const handleUpdateSubjects = async (item: any) => {
        const updatedData = { ...currentItem.data, ...item }
        dispatch(updateCurrent(updatedData))
        
        // Если это новая интерпретация (create-diseases), сохраняем на сервер
        const id = pathname.split('/').pop() || ''
        if (id === 'create-diseases' && updatedData.name?.en) {
            try {
                const response = await postInterpretation(updatedData)
                if (response.success) {
                    // Перенаправляем на страницу созданной интерпретации
                    window.location.href = `/${getSubjectId()}/diseases/${response.data._id}`
                }
            } catch (error) {
                console.error('Error saving interpretation:', error)
            }
        }
    }

    let signalSets = currentItem?.data?.signalSets || []
    // let signalSetsByCheckboxes = JSON.parse(JSON.stringify(currentItem?.data?.signalSetsByCheckboxes || {}))
    let selectedSignalSet = signalSets[selectedSet] || {}

    let signalsObj: any = {}

    const getKey = (item: any) => {
        let checkboxes = item?.byCheckboxes || {}
        return _.sortBy(Object.keys(checkboxes).map((id: any) => {
            let value: any = checkboxes[id] || {}
            return (id + '_' + _.sortBy(Object.keys(value)).filter(it => value[it]).join('#'))
        })).join('|')
    }


    _.each(signalSets, (item, ind) => {
        let strArr = getKey(item)
        signalsObj[strArr] ??= {count: 0, arr: []}
        signalsObj[strArr].count++;
        signalsObj[strArr].arr.push({item, ind})
    })

    // let signalSets
    let isShort = signalSets.length > 10
    let prefix = isShort ? '#' : 'Signal Set ';

    let isEditor = (global as any)?.isEditor;

    console.log("qqqqq signalSets", signalSets);
    return (
        <Container data-animch>
            {/* Language Switcher */}
            <LeftSide style={{ justifyContent: 'flex-start', marginBottom: 16, display: 'flex', alignItems: 'center' }}>
                {availableLanguages.map((lang, index) => (
                    <div key={lang} style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        marginRight: index < availableLanguages.length - 1 ? 8 : 0 
                    }}>
                        <NavElement
                            as="span"
                            selected={language === lang}
                            onClick={() => setLanguage(lang)}
                            style={{ cursor: 'pointer', marginRight: 4 }}
                        >
                            {lang.toUpperCase()}
                        </NavElement>
                        {lang !== 'en' && availableLanguages.length > 1 && (
                            <span
                                onClick={(e) => {
                                    e.stopPropagation()
                                    handleRemoveLanguage(lang)
                                }}
                                style={{
                                    marginLeft: 4,
                                    cursor: 'pointer',
                                    color: '#ff4444',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}
                            >
                                ×
                            </span>
                        )}
                    </div>
                ))}
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setIsAddLanguageModalOpen(true)}
                    style={{ marginLeft: 8, fontSize: '12px', padding: '4px 8px' }}
                >
                    + Add Language
                </Button>
            </LeftSide>

                <TitleDescriptionInput
                callback={(data) => {
                    if (data.description !== undefined) {
                        setLocalDescription(data.description)
                    }
                    handleUpdateSubjects(data)
                }}
                name={typeof currentInterpretation?.name === 'object' 
                    ? currentInterpretation.name[language] || (language !== 'en' ? '' : currentInterpretation.name['en'] || '')
                    : currentInterpretation?.name || ''}
                description={localDescription}
                language={language}
                onLanguageChange={(lang, field, value) => {
                    const currentData = currentItem?.data || {}
                    const currentField = currentData[field] || {}
                    
                    if (field === 'description') {
                        setLocalDescription(value)
                    }
                    
                    const updatedField = typeof currentField === 'object' 
                        ? { ...currentField, [lang]: value }
                        : { en: currentField || '', [lang]: value }
                    
                    dispatch(updateCurrent({ [field]: updatedField }))
                }}
            />

            <Body>
                <Header2>
                    <SignalSet data-signal-set>
                        {signalSets.map((_: any, index: number) => {
                            let key = getKey(_);
                            let sObj = signalsObj[key] || {};
                            let count = sObj.count;
                            let isWarn = count > 1;

                            console.log("qqqqq sObj", sObj);
                            let title = (sObj?.arr || []).map((item: any) => {
                                let it = item?.item || {};
                                return `Signal Set Index: #${item.ind + 1}; Name: ${it.hashName || it.name || ('Signal Set #' + (item?.ind + 1)) || ''}`
                            }).join('\n');

                            return <SignalSetElem
                                data-rel
                                data-signal
                                data-is-short={isShort ? 'yes' : 'no'}
                                key={index}
                                onClick={() => setSelectedSet(index)}
                                selected={selectedSet === index}
                            >
                                {!_.hashName && <>{prefix}{index + 1}</>}
                                {_.hashName && <span data-hash-name>{_.hashName}</span>}
                                {isWarn && <div style={{float: 'right'}} title={title}><WarningCircle top={-2}/></div>}
                                <div style={{marginTop: '5px'}}>
                                    <RemoveBtn
                                        right={-29}
                                        name={'Set #' + (index + 1)}
                                        top={2}
                                        onClick={() => {
                                            handleUpdateSubjects({
                                                signalSets: signalSets.filter((it: any, ind: number) => {
                                                    return ind != index;
                                                })
                                            })
                                            setSelectedSet(0)
                                        }}></RemoveBtn>
                                </div>
                            </SignalSetElem>
                        })}
                        <AddSet
                            onClick={() => {
                                signalSets = [...signalSets, {signals: []}]

                                handleUpdateSubjects({
                                    signalSets,
                                })
                                setSelectedSet(signalSets.length - 1)
                            }}
                        >
                            <AddIcon/>
                            <p>Create New Set</p>
                        </AddSet>
                    </SignalSet>

                    {isEditor && <HeadButton>
                        <MyModal title={'Connect to new Signal'} width={200}>
                            <IndicatorsSignalTable
                                language={language}
                                // connectIds={(selectedSignalSet.signals || []).reduce(
                                //     (acc: any, it: any) => {
                                //         return {...acc, [it.indicatorId]: signalSetsByCheckboxes[it.indicatorId]}
                                //     },
                                //     {}
                                // )}
                                connectIds={selectedSignalSet?.byCheckboxes || {}}
                                // signalSetsByCheckboxes={signalSetsByCheckboxes}
                                onConnect={(
                                    indicator: any,
                                    signal: any,
                                    signalIndex: number,
                                    status: boolean,
                                ) => {


                                    let indId = indicator?._id;

                                    let byCheckboxes = JSON.parse(JSON.stringify(selectedSignalSet?.byCheckboxes || {}))
                                    console.log('qqqqq Connectttttttttttttttt', selectedSignalSet, selectedSignalSet, indId, status, signalIndex)
                                    byCheckboxes = byCheckboxes || {}
                                    byCheckboxes[indId] = byCheckboxes[indId] || {}
                                    if (status) {
                                        byCheckboxes[indId][signalIndex] = status;
                                    } else {
                                        delete byCheckboxes[indId][signalIndex]
                                    }
                                    if (!Object.keys(byCheckboxes[indId])?.length) {
                                        delete byCheckboxes[indId];
                                    }

                                    let _signalSets = [...signalSets]
                                    _signalSets[selectedSet] = {...selectedSignalSet, byCheckboxes};

                                    console.log('qqqqq Connectttttttttttttttt 2222', selectedSignalSet, status)
                                    // handleUpdateSubjects({signalSets: , signalSetsByCheckboxes})
                                    handleUpdateSubjects({signalSets: _signalSets})
                                }}
                            ></IndicatorsSignalTable>
                        </MyModal>

                    </HeadButton>}
                </Header2>


                <IdInterPretationsTable
                    data={Object.keys(selectedSignalSet?.byCheckboxes || {}).map(
                        (indId: any) => {
                            console.log("qqqqq aaaaaaaaaaaaaaaaaaaaaaaa", indId, indicators);
                            return {
                                indicator: indicators[indId],
                                signalByCheckboxes: (selectedSignalSet?.byCheckboxes || {})[indId]
                            }
                        }
                    )}
                />
                <HashTagName value={selectedSignalSet.hashName} onChange={(value: string) => {
                    let _signalSets = [...signalSets]
                    _signalSets[selectedSet] = {...selectedSignalSet, hashName: value};
                    handleUpdateSubjects({signalSets: _signalSets})

                }}></HashTagName>
                <div className="pull-right">
                    <CSVUploader onChange={(v: any) => {
                        signalSets = [...signalSets, ...signalSets, ...v]
                        signalSets = v;

                        handleUpdateSubjects({
                            signalSets,
                        })
                        setSelectedSet(0)
                    }}></CSVUploader>
                </div>
                <Header bottom={'0px'} style={{display: 'flex'}}>
                    <h3>Recommendations:</h3>
                    {isEditor && <HeadButton>
                        <MyModal title={'Connect to new Recommendation'}>
                            <RecommendationsTable
                                language={language}
                                connectIds={objectify(
                                    (currentItem.data || {}).recommendationIds || []
                                )}
                                onConnect={(it: any, ind: any, status: string) => {
                                    let _ids = (currentItem.data || {}).recommendationIds || []
                                    if (status) {
                                        handleUpdateSubjects({
                                            recommendationIds: _.uniq([it._id, ..._ids]),
                                        })
                                    } else {
                                        handleUpdateSubjects({
                                            recommendationIds: _ids.filter(
                                                (item: any) => item != it._id
                                            ),
                                        })
                                    }
                                }}
                            />
                        </MyModal>
                    </HeadButton>}
                </Header>
                <IdRecommendationsTable
                    data={((currentItem.data || {}).recommendationIds || []).map(
                        (id: any) => recommendations[id]
                    )}
                />

            </Body>

            {/* Add Language Modal */}
            <Dialog open={isAddLanguageModalOpen} onClose={() => setIsAddLanguageModalOpen(false)}>
                <DialogTitle>Add New Language</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        label="Language Code"
                        value={selectedNewLanguage}
                        onChange={(e) => setSelectedNewLanguage(e.target.value)}
                        placeholder="e.g., fr, es, ru"
                        inputProps={{ maxLength: 2 }}
                        style={{ marginTop: 16 }}
                        helperText="Enter 2-letter language code (e.g., fr for French, es for Spanish)"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsAddLanguageModalOpen(false)}>Cancel</Button>
                    <Button
                        onClick={handleAddLanguage}
                        variant="contained"
                        disabled={
                            !selectedNewLanguage ||
                            selectedNewLanguage.length > 2 ||
                            availableLanguages.includes(selectedNewLanguage.toLowerCase())
                        }
                    >
                        Add Language
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    )
}

const HashTagName = (props: any) => {
    let [_value, _setValue] = useState('')
    useEffect(() => {
        _setValue(props.value || '')
    }, [props.value])
    let {onChange} = props;
    let isEditor = (global as any)?.isEditor;

    return <>
        <input
            disabled={!isEditor}
            value={_value} onChange={(e) => {
            _setValue(e.target.value)
        }}></input>
        <button
            disabled={!isEditor}
            className='btn big' onClick={() => {
            onChange(_value)
        }}>Update Signal Set HashName
        </button>
    </>

}


export default Interpretations
